export default __webpack_public_path__ + "52d8d857a30406fb8d1fa61caa6a1866.wav";